import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-loop-post-type-filter-settings',
  styleUrls: ['./post-type-filter-settings.component.scss'],
  templateUrl: './post-type-filter-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PostTypeFilterSettingsComponent implements OnInit {
  @Input() parentForm: UntypedFormGroup;
  filters: UntypedFormArray;

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.filters = this.parentForm.get('filters') as UntypedFormArray;
  }

  addFilter(event): void {
    event.preventDefault();
    this.filters.push(
      this.fb.group({
        label: ['', Validators.required],
        value: this.fb.group({
          id: ['', Validators.required],
          valuePath: ['', Validators.required],
        }),
        options: this.fb.array([]),
      }),
    );
  }

  removeFilter(event, index): void {
    event.preventDefault();
    this.filters.removeAt(index);
  }

  addOption(event, filterIndex): void {
    event.preventDefault();
    (this.filters.at(filterIndex).get('options') as UntypedFormArray).push(
      this.fb.group({
        id: ['', Validators.required],
        value: ['', Validators.required],
      }),
    );
  }

  removeOption(event, filterIndex, index): void {
    event.preventDefault();
    (this.filters.at(filterIndex).get('options') as UntypedFormArray).removeAt(index);
  }
}
